import { Injectable } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { AnonymousConsentsService, BaseSiteService, ConsentService, CxEvent } from '@spartacus/core';
import { TmsCollector, WindowObject } from '@spartacus/tracking/tms/core';
import { combineLatest, map } from 'rxjs';
import { TwqCollectorConfig } from './config/twq-collector.config';
import { EnvironmentService } from './environment.service';

declare let twq: Function;

@Injectable({
  providedIn: 'root',
})
export class TwqCollectorService implements TmsCollector {
  constructor(
    private environmentService: EnvironmentService,
    private consentService: ConsentService,
    private baseSiteService: BaseSiteService
  ) {}

  consentCookie$ = this.consentService.checkConsentGivenByTemplateId('ANALYTICS');

  init(config: TwqCollectorConfig, windowObject: WindowObject): void {
    combineLatest([this.consentCookie$, this.baseSiteService.getActive()])
      .pipe(takeUntilDestroyed())
      .subscribe(([analyticsAllowed, activeSiteId]) => {
        const twqId: string | undefined = activeSiteId
          ? this.environmentService.getCurrentEnvironment().tracking.twitter.pixel.id[activeSiteId]
          : undefined;

        if (analyticsAllowed && twqId) {
          // Defer Twitter script loading to improve TTFB
          this.loadTwitterScript(windowObject, twqId);
        }
      });
  }

  private loadTwitterScript(windowObject: WindowObject, twqId: string): void {
    if ('requestIdleCallback' in window) {
      requestIdleCallback(() => this.createTwitterScript(windowObject, twqId), { timeout: 5000 });
    } else {
      setTimeout(() => this.createTwitterScript(windowObject, twqId), 2000);
    }
  }

  private createTwitterScript(windowObject: WindowObject, twqId: string): void {
    // @ts-ignore
    !(function (e: WindowObject, t: Document, n: string, s: any, u: any, a: any) {
      if (e['twq']) return;
      s = e['twq'] = function () {
        s.exe ? s.exe.apply(s, arguments) : s.queue.push(arguments);
      };
      s.version = '1.1';
      s.queue = [];
      u = t.createElement(n);
      u.async = !0;
      u.defer = true;
      u.src = '//static.ads-twitter.com/uwt.js';
      a = t.getElementsByTagName(n)[0];
      a.parentNode.insertBefore(u, a);
    })(window, document, 'script');

    twq('init', twqId);
    twq('track', 'PageView');
  }

  pushEvent<T extends CxEvent>(config: TwqCollectorConfig, windowObject: WindowObject, event: any): void {}
}
